import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectLocationsAvailable = createSelector(
  [
    (store: RootState) => store.formSubmittedSlice.locationList,
    (store: RootState) => store.formSubmittedSlice.searchLocationText,
    (store: RootState) => store.formSubmittedSlice.createFilters,
    (store: RootState) => store.formSubmittedSlice.selectedLocations
  ],
  (locationList, searchText, createFilters, selectedLocations) => {
    const data = locationList.filter(
      ({ id, name, organization, code }) => {
        // Descarta los location que no tengan code XXX-XXX
        if (code?.trim().length != 7) {
          return false;
        }
        if (
          searchText
          && !name?.toLowerCase().includes(searchText?.toLowerCase().trim())
          && !code?.toLowerCase().includes(searchText?.toLowerCase().trim())
        ) {
          return false;
        }
        // Filtro por organization (Cliente)
        if (createFilters.organization.id && organization?.id !== createFilters.organization.id) {
          return false;
        }

        // Descarta los locations que ya están seleccionados o asignados
        if (selectedLocations.find(({ id: slId }) => slId === id)) {
          return false;
        }

        return true
      }
    );
    // Ordena la lista alfabeticamente
    const orderedList = [...data].sort((a, b) => {
      if (a.name && b.name && a.name < b.name) {
        return -1;
      }
      if (a.name && b.name && a.name > b.name) {
        return 1;
      }
      return 0;
    });

    return orderedList;
  });
